const rules = (acl) => {
  acl.rule('view', 'Home', (store) => {
    return store.getters.logInStatus
  })

  acl.rule('view', 'Login', (store) => {
    return !store.getters.logInStatus
  })

  acl.rule('view', 'Logout', (store) => {
    return store.getters.logInStatus
  })

  acl.rule('view', 'OnboardClient', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'Services', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('view', 'Products', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'Inventories', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('view', 'Plans', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('view', 'EventChecklist', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager', 'vendor'].includes(item))
  })

  acl.rule('view', 'SelectCrew', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'Reminders', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'dispatcher', 'case-manager'].includes(item))
  })

  acl.rule('view', 'Analytics', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'Billing', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'accounts', 'vendor'].includes(item))
  })

  acl.rule('view', 'InventoryReport', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('view', 'Users', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('view', 'Clients', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'Cases', (store) => {
    return store.getters.currentUserRoles.some(item => ['vendor', 'case-manager', 'management', 'trainer', 'case-crew', 'warehouse-manager', 'warehouse-crew', 'accounts', 'customer-support', 'embalmer'].includes(item))
  })

  acl.rule('view', 'Profile', (store) => {
    return store.getters.currentUserRoles.some(item => ['vendor', 'case-manager', 'management', 'trainer', 'case-crew', 'warehouse-manager', 'warehouse-crew', 'accounts', 'customer-support', 'embalmer'].includes(item))
  })

  // old
  acl.rule('view', 'NewCase', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'trainer', 'case-crew', 'warehouse-manager', 'warehouse-crew', 'accounts', 'customer-support', 'embalmer'].includes(item))
  })

  acl.rule('view', 'NewLeads', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager', 'dispatcher'].includes(item))
  })

  acl.rule('view', 'AssignCrewAndTiming', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager', 'dispatcher'].includes(item))
  })

  acl.rule('view', 'SelectPlanAndVendors', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'AppointmentSchedule', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item)) || store.getters.currentUser.is_palbearer
  })

  acl.rule('view', 'AddLeadForm', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'dispatcher', 'case-manager'].includes(item))
  })

  acl.rule('view', 'Bookings', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'VendorsInvoice', (store) => {
    return true
  })

  acl.rule('view', 'Settings', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('view', 'WhatsappNotifications', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('view', 'SMSNotifications', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'Notifications', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'CasesDetail', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager', 'vendor', 'trainer', 'case-crew', 'warehouse-manager', 'warehouse-crew', 'accounts', 'customer-support', 'embalmer'].includes(item))
  })

  acl.rule('view', 'PDFTemplates', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('view', 'Roles', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('view', 'cases-detail-case-description-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'cases-detail-client-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'cases-detail-plan-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'cases-detail-services-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager', 'vendor'].includes(item))
  })

  acl.rule('view', 'cases-detail-inventories-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('view', 'cases-detail-pdf-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'vendor', 'case-manager', 'accounts'].includes(item))
  })

  acl.rule('view', 'cases-detail-invoices', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'vendor', 'case-manager', 'accounts'].includes(item))
  })

  acl.rule('view', 'cases-detail-forms', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'cases-detail-chat-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager', 'vendor', 'trainer', 'case-crew', 'warehouse-manager', 'warehouse-crew', 'accounts', 'customer-support', 'embalmer'].includes(item))
  })

  acl.rule('create', 'cases-item', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('edit', 'cases-item', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('delete', 'cases-item', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('close', 'cases-item', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager', 'accounts'].includes(item))
  })

  acl.rule('send', 'cases-client-email', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('mark-paid', 'invoices', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'accounts'].includes(item))
  })

  acl.rule('view', 'cases-detail-checklist-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'cases-detail-checklist-crew-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['vendor'].includes(item))
  })

  acl.rule('view', 'cases-detail-embalming-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager', 'embalmer'].includes(item))
  })

  acl.rule('view', 'cases-detail-actions-log-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('view', 'cases-detail-agreement-feedback-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'cases-detail-deposits-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'cases-detail-commissions-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('edit', 'case-deposit', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'cases-detail-actions-tab', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'dispatcher'].includes(item))
  })

  acl.rule('add', 'checklist-item', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('add', 'new-commissions-to-case-manager', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('delete', 'checklist-item', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('edit', 'checklist-item', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('view', 'cases-all-list', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager'].includes(item))
  })

  acl.rule('use', 'appointment-schedule-create-new-case', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager', 'dispatcher'].includes(item))
  })

  acl.rule('use', 'appointment-schedule-click-event', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager', 'dispatcher'].includes(item))
  })

  acl.rule('view', 'Caskets', (store) => {
    return store.getters.currentUserRoles.some(item => ['management', 'case-manager', 'vendor', 'trainer', 'case-crew', 'warehouse-manager', 'warehouse-crew', 'accounts', 'customer-support', 'embalmer'].includes(item))
  })

  acl.rule('create', 'Caskets', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('edit', 'Caskets', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('delete', 'Caskets', (store) => {
    return store.getters.currentUserRoles.some(item => ['management'].includes(item))
  })

  acl.rule('view', 'vendor', (store) => {
    return store.getters.currentUserRoles.some(item => ['vendor'].includes(item))
  })
}

export default rules



// WEBPACK FOOTER //
// ./src/config/acl.js